import React, { Component } from 'react'
import { AsyncTypeahead, Typeahead } from 'react-bootstrap-typeahead';

class FaAsyncTypeahead extends Component {

  state = {
    selected: null,
    ref: React.createRef()
  }

  componentDidMount() {
    const { onSetRef, id, name } = this.props;

    if (!!onSetRef) {
      const { ref } = this.state;

      onSetRef({
        name: id || name,
        ref
      });
    }
  }

  handleOnChange = (items) => {
    const [ item ] = items;

    this.props.onSelect(item);

    this.setState({
      selected: item
    });
  }

  renderMenuItems = (option) => {
    return !!this.props.renderMenuItem ? this.props.renderMenuItem(option) : this._renderMenuItem(option);
  }

  _handlePagination = (e, shownResults) => {
    const { pagination, filters } = this.props.container.state;
    const page = (pagination.page || pagination.current_page) + 1;

    this.props.container.paginate({
      ...filters,
      page: page,
    });
  };

  _handleSearch = query => {
    const { filters } = this.props.container.state;

    this.props.container.paginate({
      page: 1,
      ...filters,
      search: query
    });

    if (query === '') {
      this.props.onSelect();

      this.setState({
        selected: null
      });
    }
  };

  _handleOnBlur = () => {
    const { selected, ref } = this.state;

    if (!selected) {
      ref.current.clear()
    }
  }

  _renderMenuItem = option => (
    <div key={ option.id }>
      <span>{ option.label }</span>
    </div>
  )

  render() {
    const { ref } = this.state;
    const { paginate = true, onChange, options = [], container, search = '', isLoading, minLength = 2, delay = 1000, filterBy = () => true, ...rest } = this.props;

    if (!container) {
      return <Typeahead
        autoComplete={ false }
        options={ options || []}
        maxResults={ undefined }
        paginate={ false }
        ref={ ref }
        onBlur={ this._handleOnBlur }
        onChange={ this.handleOnChange }
        renderMenuItemChildren={ this.renderMenuItems }
        { ...rest }
      />
    }

    const { data, busy, pagination } = container.state;

    return (
      <AsyncTypeahead
        paginate={ paginate }
        options={ data }
        isLoading={ busy }
        autoComplete={ false }
        query={ search }
        useCache={ false }
        maxResults={ !!pagination ? pagination.limit - 1 : undefined }
        minLength={ minLength }
        ref={ ref }
        delay={ delay }
        filterBy={ filterBy }
        onChange={ this.handleOnChange }
        onPaginate={ this._handlePagination }
        onSearch={ this._handleSearch }
        onBlur={ this._handleOnBlur }
        renderMenuItemChildren={ this.renderMenuItems }
        { ...rest }
      />
    )
  }
}

export default FaAsyncTypeahead;